import React, { Component, useState, useEffect, useCallback, useRef} from 'react';
import axios from 'axios';
import { Label, Form, FormGroup, Input, Row, Col, Table } from 'reactstrap';
import { DetailsList, FontIcon, DetailsListLayoutMode, mergeStyles, SelectionMode, MessageBar, TooltipHost, DefaultButton} from '@fluentui/react';
import { authProvider } from '../authProvider';
import moment from 'moment';
const columns = [
    {
        key: "iconKey",
        name: "Status",
        minWidth: 45,
        maxWidth: 45,
        onRender: (item) => {
            if (item.formulaVersion == item.currentFormulaVersion) {
                return (
                    <TooltipHost content={"This estimate was saved with the current version of the formulas and fields."}>
                        <FontIcon aria-label="Ok" iconName="SkypeCircleCheck" className={okClass} />
                    </TooltipHost>)
            }
            else {
                return (
                    <TooltipHost content="Warning! This estimate was generated with current field and formulas!">
                        <FontIcon aria-label="Warning" iconName="Warning" className={warningClass} />
                    </TooltipHost>)
            }

        },
        
    },
    {
        key: "CompanyKey",
        fieldName: "companyName",
        name: "Company",
        minWidth: 200,
        maxWidth: 200,
      
    },
    {
        key: "ProductKey",
        fieldName: "smsTypeName",
        name: "Product",
        minWidth: 200,
        maxWidth: 200,
       
    },
    {
        key: "RevenueKey",
        fieldName: "revenue",
        name: "Revenue",
        minWidth: 150,
        maxWidth: 200,
       
    },
    {
        key: "IndustryKey",
        fieldName: "industry",
        name: "Industry",
        minWidth: 150,
        maxWidth: 200,
       
    },
    {
        key: "UpdatedByKey",
        fieldName: "lastSavedBy",
        name: "Updated By",
        minWidth: 200,
        maxWidth: 200,
      
    },
    {
        key: "UpdatedOnKey",
        name: "Updated On",
        fieldName: "lastSavedOn",
        onRender: (item) => {
            return (<span>{moment(item.lastSavedOn).format("lll")}</span>);
        },
        minWidth: 150,
        maxWidth: 150,
        isSorted: true,
        isSortedDescending: true
    },
];

const warningClass = mergeStyles({
    color: "red"
});
const okClass = mergeStyles({
    color: "green"
});

const rootUrl = window.location.protocol + '//' + window.location.host + '/';
//< th > Created By</th>
//                        <th>Created On</th>
//                        <th>Updated By</th>
//                        <th>Updated On</th>
 const EstimateList= (props)=>{
   
    const [currentCount, setCurrentCount] = useState(0);
    const [token, setToken] = useState('');
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [headers, setHeaders] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [searchIndustry, setSearchIndustry] = useState(0);
    const [searchRevenue, setSearchRevenue] = useState(0);
    const [estimates, setEstimates] = useState([]);
    const [myEstimates, setMyEstimates] = useState(false);
    const [revenues, setRevenues] = useState([]);
    const [industries, setIndustries] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [listColumns, setListColumns] = useState(columns);
    const [sortColumn, setSortColumn] = useState("lastSavedOn");
    const [sortDescending, setSortDescending] = useState(true);
    
    const columnsRef = useRef([]);
    columnsRef.current = listColumns;
    const getEstimatesInternal = (page, searchIndustry, searchRevenue, headers, sortColumn, sortDescending)=>{
        var skip = (page - 1) * 20;
        var take = 20;
        var url = '?skip=' + skip + '&take=' + take;
        url = url + '&myEstimates=' + myEstimates;
        if (searchIndustry > 0) {
            url = url + '&industryId=' + searchIndustry;
        }
        if (searchRevenue > 0) {
            url = url + '&revenueId=' + searchRevenue;
        }
        url = url + "&sortColumn=" + sortColumn + "&sortDescending=" + (sortDescending ? "true" : "false")
        var searchUrl = rootUrl + "SmsEstimates" + url;
        var countUrl = rootUrl + "SmsEstimates/Count" + url;
        axios.get(searchUrl, { headers: headers }).then(res => {
            setCurrentPage(page);
            setEstimates(res.data);
        });
        axios.get(countUrl, { headers: headers }).then(res => {
            var estCount = res.data;
            var totalPages = Math.ceil(estCount / 20);
            setTotalPages(totalPages);
            setCurrentCount(estCount)

            //updatePaging(res.data);
        });
    }
    const openEstimate = (estimateId)=>{
        window.location.href = "/Estimate/" + estimateId;
    };
    const getEstimates = useCallback((page)=>{
      getEstimatesInternal(page, searchIndustry, searchRevenue, headers, sortColumn, sortDescending);
    }, [myEstimates, searchIndustry, searchRevenue, headers, sortColumn, sortDescending, getEstimatesInternal])
    
    const loadLookupsBase = (headers)=>{
        axios.get(rootUrl + "Industry", { headers: headers }).then(res => {
            if (res.data) {
                var lIndustries = res.data;
                lIndustries.splice(0, 0, { id: 0, name: "Not Selected" })
                setIndustries(lIndustries );
            }
        });
        axios.get(rootUrl + "RevenueRange", { headers: headers }).then(res => {
            if (res.data) {
                var lRevenues = res.data;
                lRevenues.splice(0, 0, { id: 0, rangeText: "NotSelected" })
                setRevenues(lRevenues);
            }
        })
    }
    const loadLookups = useCallback(()=>{
        loadLookupsBase(headers);
    }, [headers]);
    const onColumnClick = useCallback((ev, column)=>{
        if (column.name == "Status"){
            return;
        }
        const newColumns = listColumns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
        var sortColumn="";
        var sortDescending = "";
        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
                sortDescending = currColumn.isSortedDescending;
                sortColumn = currColumn.fieldName
                setSortDescending(sortDescending);
                setSortColumn(sortColumn);
             
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = true;
            }
        });
        setListColumns(newColumns);
        getEstimatesInternal(currentPage, searchIndustry, searchRevenue, headers,sortColumn, sortDescending);
    },[currentPage, searchIndustry, searchRevenue, headers, listColumns, getEstimatesInternal]); 
    const goToPreviousPage = useCallback(()=>{
        if (currentPage > 1)
        {
            getEstimates(currentPage - 1);
        }
    }, [currentPage, getEstimates])
    const goToNextPage = useCallback(()=>{
        if (currentPage < totalPages){
            getEstimates(currentPage + 1);
        }
    }, [currentPage, getEstimates])
    const goToPage = useCallback((page)=>{
        if (page > 0 && page <= totalPages){
            getEstimates(page);
        }
    }, [getEstimates]);
  
    const onMyEstimatesChange = useCallback((event)=>{
        setMyEstimates(event.target.type === 'checkbox' ? event.target.checked: event.target.value);
        getEstimates(0);
    }, [getEstimates])
    const onSearchIndustryChange = useCallback((event)=>{
        setSearchIndustry(event.target.value);
        getEstimates(0);
    }, [getEstimates]);
    const onSearchRevenueChange = useCallback((event)=>{
        setSearchRevenue(event.target.value);
        getEstimates(0);
    }, [getEstimates]);
    var getFrom = ()=>{
        return ((currentPage - 1) * 20) + 1;
    }
    var getThru = ()=>{
        var thru = currentPage * 20;
        if (thru > currentCount){
            thru = currentCount;
        }
        return thru;
    }
   var setColumnClickEvent = (listColumns, onColumnClick)=>{
        if (!listColumns)
            return [];
        const newColumns = listColumns.slice();
        newColumns.forEach((newCol) => {
            newCol.onColumnClick=onColumnClick;
        });
        return newColumns;
      };
    var clickableColumns = setColumnClickEvent(listColumns, onColumnClick); 
    useEffect(()=>{

        authProvider.getAccessToken().then(function (result) {
            console.log(result);
            var tkn = result.accessToken;

            if (tkn) {
                setToken(tkn);
                setIsAuthorized(true);
                var headers = { 'Authorization': "Bearer " + tkn }
                setHeaders( headers);
                
                
                getEstimatesInternal(1, "", "",headers, sortColumn, sortDescending);
                loadLookupsBase(headers);
                //setColumnClickEvent(listColumns, onColumnClick);
            }
            else {
                console.log("Token not acquired!")
            }
        });
    
    
    }, []);

    return (
        <div>
            <Form>
                <Row form md={4}>
                    <Col>
                        <FormGroup>
                            <Label for="searchIndustry">Industry Filter</Label>
                            <Input type="select" id="searchIndustry" value={searchIndustry} onChange={onSearchIndustryChange}>
                                {industries.map((item, ind) => <option key={ind} value={item.id}>{item.name}</option>)}
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col><FormGroup>
                        <Label for="searchRevenue">Revenue Filter</Label>
                        <Input type="select" id="searchRevenue" value={searchRevenue} onChange={onSearchRevenueChange}>
                            {revenues.map((item, ind) => <option key={ind} value={item.id}>{item.rangeText}</option>)}
                        </Input>
                    </FormGroup></Col>
                    <Col>
                        <FormGroup check>
                            <Label check>
                                <Input type="checkbox" checked={myEstimates} onChange={onMyEstimatesChange} />
                                Only My Estimates
                            </Label>
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
            <MessageBar>Double click an item from the list to open it.</MessageBar>
            <DetailsList
                items={estimates}
                columns={clickableColumns}
                compact={true}
                selectionMode={SelectionMode.none}
                layoutMode={DetailsListLayoutMode.justified}
                onItemInvoked={(item) => { openEstimate(item.id); }} 
                
                />
                <div style={{display:"inline-block"}}>Displaying {getFrom()} thru {getThru()} of {currentCount}</div>
            <div style={{display: "flex"}}>
                <DefaultButton disabled={currentPage == 1} onClick={goToPreviousPage}>Previous</DefaultButton>
                {Array.from(Array(totalPages).keys()).map((ind)=>{
                    var page = ind + 1;
                    return <DefaultButton disabled={page == currentPage} onClick={()=>goToPage(page)}>{page}</DefaultButton>
                })}
                <DefaultButton disabled={currentPage == totalPages} onClick={goToNextPage}>Next</DefaultButton>
                
            </div>
            
        </div>
    );
 }
 export default EstimateList;
// export class EstimateList extends Component {
//     static displayName = EstimateList.name;

//     constructor(props) {
//         super(props);
//         var columns = [
//             {
//                 key: "iconKey",
//                 name: "Status",
//                 minWidth: 45,
//                 maxWidth: 45,
//                 onRender: (item) => {
//                     if (item.formulaVersion == item.currentFormulaVersion) {
//                         return (
//                             <TooltipHost content={"This estimate was saved with the current version of the formulas and fields."}>
//                                 <FontIcon aria-label="Ok" iconName="SkypeCircleCheck" className={okClass} />
//                             </TooltipHost>)
//                     }
//                     else {
//                         return (
//                             <TooltipHost content="Warning! This estimate was generated with current field and formulas!">
//                                 <FontIcon aria-label="Warning" iconName="Warning" className={warningClass} />
//                             </TooltipHost>)
//                     }

//                 },
//                 onColumnClick:this.onColumnClick

//             },
//             {
//                 key: "CompanyKey",
//                 fieldName: "companyName",
//                 name: "Company",
//                 minWidth: 200,
//                 maxWidth: 200,
//                 onColumnClick:this.onColumnClick
//             },
//             {
//                 key: "ProductKey",
//                 fieldName: "smsTypeName",
//                 name: "Product",
//                 minWidth: 200,
//                 maxWidth: 200,
//                 onColumnClick:this.onColumnClick
//             },
//             {
//                 key: "RevenueKey",
//                 fieldName: "revenue",
//                 name: "Revenue",
//                 minWidth: 150,
//                 maxWidth: 200,
//                 onColumnClick:this.onColumnClick
//             },
//             {
//                 key: "IndustryKey",
//                 fieldName: "industry",
//                 name: "Industry",
//                 minWidth: 150,
//                 maxWidth: 200,
//                 onColumnClick:this.onColumnClick
//             },
//             {
//                 key: "UpdatedByKey",
//                 fieldName: "lastSavedBy",
//                 name: "Updated By",
//                 minWidth: 200,
//                 maxWidth: 200,
//                 onColumnClick:this.onColumnClick
//             },
//             {
//                 key: "UpdatedOnKey",
//                 name: "Updated On",
//                 onRender: (item) => {
//                     return (<span>{moment(item.createdOn).format("lll")}</span>);
//                 },
//                 minWidth: 150,
//                 maxWidth: 150,
//                 onColumnClick:this.onColumnClick
//             },
//         ];
//         var rootUrl = window.location.protocol + '//' + window.location.host + '/';
//         this.state = { listColumns: columns, currentCount: 0, rootUrl: rootUrl, token: '', isAuthorized: false, headers: {}, currentPage: 1, 
//         searchIndustry: 0, searchRevenue: 0, estimates: [], myEstimates: false, estimates: [], revenues: [], industries: [] };


//         this.componentDidMount = this.componentDidMount.bind(this);
//         this.get_estimates = this.get_estimates.bind(this);
//         this.load_lookups = this.load_lookups.bind(this);
//         this.onMyEstimatesChange = this.onMyEstimatesChange.bind(this);
//         this.onSearchIndustryChange = this.onSearchIndustryChange.bind(this);
//         this.onSearchRevenueChange = this.onSearchRevenueChange.bind(this);
//         this.render_pages = this.render_pages.bind(this);
//         this.go_to_next_page = this.go_to_next_page.bind(this);
//         this.go_to_previous_page = this.go_to_previous_page.bind(this);
//         this.go_to_page = this.go_to_page.bind(this);
//         this.update_paging = this.update_paging.bind(this);
//         this.onColumnClick = this.onColumnClick.bind(this);
//         //this.get_page_count = this.get_page_count.bind(this);
//     }
//     componentDidMount() {
//         var self = this;

//         authProvider.getAccessToken().then(function (result) {
//             console.log(result);
//             var tkn = result.accessToken;

//             if (tkn) {

//                 self.setState({ token: tkn, isAuthorized: true, headers: { 'Authorization': "Bearer " + tkn }, totalPages: 0, });
//                 self.get_estimates(0);
//                 self.load_lookups();
//             }
//             else {
//                 console.log("Token not acquired!")
//             }
//         })
//     }
//     openEstimate(estimateId) {
//         window.location.href = "/Estimate/" + estimateId;
//     }
//     get_estimates(page) {


//         var skip = (page - 1) * 10;
//         var take = 10;
//         var url = '?skip=' + skip + '&take=' + take;
//         url = url + '&myEstimates=' + this.state.myEstimates;
//         if (this.state.searchIndustry > 0) {
//             url = url + '&industryId=' + this.state.searchIndustry;
//         }
//         if (this.state.searchRevenue > 0) {
//             url = url + '&revenueId=' + this.state.searchRevenue;
//         }

//         var searchUrl = this.state.rootUrl + "SmsEstimates" + url;
//         var countUrl = this.state.rootUrl + "SmsEstimates/Count" + url;
//         axios.get(searchUrl, { headers: this.state.headers }).then(res => {

//             this.setState({ currentPage: page, estimates: res.data });
//         });
//         axios.get(countUrl, { headers: this.state.headers }).then(res => {

//             this.setState({ currentCount: res.data });
//             this.update_paging(res.Data);
//         });
//     }
//     load_lookups() {
//         axios.get(this.state.rootUrl + "Industry", { headers: this.state.headers }).then(res => {
//             if (res.data) {
//                 var industries = res.data;
//                 industries.splice(0, 0, { id: 0, name: "Not Selected" })
//                 this.setState({ industries: industries });
//             }
//         });
//         axios.get(this.state.rootUrl + "RevenueRange", { headers: this.state.headers }).then(res => {
//             if (res.data) {
//                 var revenues = res.data;
//                 revenues.splice(0, 0, { id: 0, rangeText: "NotSelected" })
//                 this.setState({ revenues: revenues });
//             }
//         })
//     }
//     go_to_previous_page() {
//         const page = this.state.currentPage;
//         if (page > 1)
//             this.get_estimates(page - 1);
//     }
//     go_to_next_page() {
//         const page = this.state.currentPage;

//     }
//     go_to_page(pageNum) {

//     }
//     update_paging() {

//     }
//     render_pages() {

//     }
//     onMyEstimatesChange(event) {
//         // unlike textboxes, it appears the checked property is updating
//         // the state.
//         const state = this.state;
//         const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
//         state.myEstimates = value;
//         this.setState({ myEstimates: value });
//         this.get_estimates(0);
//     }
//     onSearchIndustryChange(event) {
//         const state = this.state;
//         state.searchIndustry = event.target.value;
//         this.setState({ searchIndustry: state.searchIndustry });
//         this.get_estimates(0);
//     }
//     onSearchRevenueChange(event) {
//         const state = this.state;
//         state.searchRevenue = event.target.value;
//         this.setState({ searchRevenue: state.searchRevenue });
//         this.get_estimates(0);
//     }
//     onColumnClick(ev, column) {
//         const listColumns = this.state.listColumns;
//         const newColumns = listColumns.slice();
//         const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];
//         newColumns.forEach((newCol) => {
//             if (newCol === currColumn) {
//                 currColumn.isSortedDescending = !currColumn.isSortedDescending;
//                 currColumn.isSorted = true;
//                 this.setState({
//                     announcedMessage: `${currColumn.name} is sorted ${currColumn.isSortedDescending ? 'descending' : 'ascending'
//                         }`,
//                 });
//             } else {
//                 newCol.isSorted = false;
//                 newCol.isSortedDescending = true;
//             }
//         });
//         // const newItems = _copyAndSort(items, currColumn.fieldName, currColumn.isSortedDescending);
//         // this.setState({
//         //   columns: newColumns,
//         //   items: newItems,
//         // });
//     };

//     render() {

//         const estimates = this.state.estimates;
//         const listColumns = this.state.listColumns;
//         return (
//             <div>
//                 <Form>
//                     <Row form md={4}>
//                         <Col>
//                             <FormGroup>
//                                 <Label for="searchIndustry">Industry Filter</Label>
//                                 <Input type="select" id="searchIndustry" value={this.state.searchIndustry} onChange={this.onSearchIndustryChange}>
//                                     {this.state.industries.map((item, ind) => <option key={ind} value={item.id}>{item.name}</option>)}
//                                 </Input>
//                             </FormGroup>
//                         </Col>
//                         <Col><FormGroup>
//                             <Label for="searchRevenue">Revenue Filter</Label>
//                             <Input type="select" id="searchRevenue" value={this.state.searchRevenue} onChange={this.onSearchRevenueChange}>
//                                 {this.state.revenues.map((item, ind) => <option key={ind} value={item.id}>{item.rangeText}</option>)}
//                             </Input>
//                         </FormGroup></Col>
//                         <Col>
//                             <FormGroup check>
//                                 <Label check>
//                                     <Input type="checkbox" checked={this.state.myEstimates} onChange={this.onMyEstimatesChange} />
//                                     Only My Estimates
//                                 </Label>
//                             </FormGroup>
//                         </Col>
//                     </Row>
//                 </Form>
//                 <MessageBar>Double click an item from the list to open it.</MessageBar>
//                 <DetailsList
//                     items={estimates}
//                     columns={listColumns}
//                     compact={true}
//                     selectionMode={SelectionMode.none}
//                     layoutMode={DetailsListLayoutMode.justified}
//                     onItemInvoked={(item) => { this.openEstimate(item.id); }} 
                    
//                     />

//                 <nav aria-label="Page navigation example">
//                     <ul className="pagination">
//                         <li className="page-item" onClick={() => { this.go_to_previous_page(); }}>Previous</li>
//                         <li className="page-item" onClick={() => { this.go_to_page(1) }}>1</li>
//                         <li className="page-item" onClick={() => { this.go_to_next_page(); }}>Next</li>
//                     </ul>
//                 </nav>
//             </div>
//         );
//     }
// }
